"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosInstance = void 0;
const axiosInstance_1 = require("@/commons/axiosInstance");
const addRequestInterceptors_1 = require("./addRequestInterceptors");
const addResponseInterceptors_1 = require("./addResponseInterceptors");
exports.axiosInstance = (0, axiosInstance_1.buildAxiosInstance)();
exports.axiosInstance.interceptors.request.use((0, addRequestInterceptors_1.addRequestSuccessInterceptor)(), (0, addRequestInterceptors_1.addErrorRequestInterceptor)());
exports.axiosInstance.interceptors.response.use((0, addResponseInterceptors_1.addResponseSuccessInterceptor)(), (0, addResponseInterceptors_1.addResponseErrorInterceptor)());
